import type { RoleEnum } from '@/gql/scalars';

type TeamMemberSettingsPermissions = Record<string, unknown>;

export type TeamMemberSettingsActions = {
  editMemberType: boolean;
  editRole: boolean;
};

export function getTeamMemberSettingsActions({
  isManaged,
  isSelf,
  permissions,
  role,
}: {
  isManaged: boolean | null | undefined;
  isSelf?: boolean | null | undefined;
  permissions: TeamMemberSettingsPermissions | null | undefined;
  role: RoleEnum | null | undefined;
}): TeamMemberSettingsActions {
  const canEditOwner = Boolean(permissions?.edit_others_role);

  return {
    editMemberType: Boolean(
      (isSelf && permissions?.edit_self) ||
        (!isSelf &&
          permissions?.edit_others &&
          (role !== 'owner' || canEditOwner)),
    ),
    editRole: Boolean(
      role &&
        !isManaged &&
        !isSelf &&
        role !== 'owner' &&
        permissions?.edit_others,
    ),
  };
}
